import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { saveFeature } from '../store/actions';
import { getFeatures } from '../store/selectors';

// TODO: think about:
// - moving to FeatureFlags service;
// - saving features to local storage in "trackingCallback";
// to delete this hook.
export function useFeatures() {
  const dispatch = useDispatch();
  const trackedFeatures = useSelector(getFeatures);

  const doSaveFeature = useCallback(
    (data: { name: string; value: string }) => {
      dispatch(saveFeature(data));
    },
    [dispatch],
  );

  return {
    saveFeature: doSaveFeature,
    trackedFeatures,
  };
}
